import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomePage } from './pages/home-page/home-page.component';
import { Modulo } from './modulos/modulo/modulo.component';
import { ModuloLogo } from './modulos/logo/logo.component';
import { MenuComponent } from './components/menu/menu.component';
import { ModuloService } from './services/modulo.service';
import { DataService } from './services/data.service';
import { AppService } from './services/app.service';
import { HttpClientModule } from '@angular/common/http';
import { HeaderComponent } from './components/header/header.component';
import { BannerSliderComponent } from './modulos/banner-slider/banner-slider.component';
import { RedeSocialComponent } from './modulos/rede-social/rede-social.component';
import { NewsletterComponent } from './modulos/newsletter/newsletter.component';
import { WhatsappComponent } from './modulos/whatsapp/whatsapp.component';
import { LazyLoadImageModule } from 'ng-lazyload-image'; //@3.4.2
import { DeviceDetectorModule } from 'ngx-device-detector';
import { FormsModule } from '@angular/forms';
import { FooterComponent } from './components/footer/footer.component';
import { FaleConoscoComponent } from './modulos/fale-conosco/fale-conosco.component';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { ParceirosComponent } from './modulos/parceiros/parceiros.component';  
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SistemaDeGestaoPage } from './pages/servicos/sistema-de-gestao-page/sistema-de-gestao-page.component';
import { EcommercePage } from './pages/servicos/ecommerce-page/ecommerce-page.component';
import { AplicativoPage } from './pages/servicos/aplicativo-page/aplicativo-page.component';
import { DashboardPage } from './pages/servicos/dashboard-page/dashboard-page.component';
import { ContatoPage } from './pages/contato-page/contato-page.component';
import { SobrePage } from './pages/sobre-page/sobre-page.component'; 
import { SejaNossoParceiroPage  } from './pages/seja-nosso-parceiro-page/seja-nosso-parceiro-page.component';
import { CasesComponent } from './modulos/cases/cases.component';
import { ModalInfo } from './components/modal/modal-info/modal-info.component';
import { LoaderComponent } from './components/loader/loader/loader.component';
import { ContatoConsultorComponent } from './modulos/contato-consultor/contato-consultor.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ServicosComponent } from './modulos/servicos/servicos.component'; 
import { GtagService } from './services/gtag.service';
import { PageErrorComponent } from './components/error/page-error/page-error.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { MenuServicosComponent } from './components/menu-servicos/menu-servicos.component';
import { FuncionalidadeItemComponent } from './components/servicos/funcionalidade-item/funcionalidade-item.component';
import { CaseItemComponent } from './components/cases/case-item/case-item.component';
import { ServicosPage } from './pages/servicos/servicos-page/servicos-page.component';
import { ModalSugestao } from './components/modal/modal-sugestao/modal-sugestao.component';
import { TopoPartialComponent } from './components/partial/topo-partial/topo-partial.component';
import { EnderecoModuloComponent } from './modulos/endereco-modulo/endereco-modulo.component';
import { ClienteModuloComponent } from './modulos/cliente-modulo/cliente-modulo.component';
import { ManagetourModuloComponent } from './modulos/managetour-modulo/managetour-modulo.component';
import { EcommerceModuloComponent } from './modulos/ecommerce-modulo/ecommerce-modulo.component';
import { ApplicativoModuloComponent } from './modulos/applicativo-modulo/applicativo-modulo.component';
import { AppTelasComponent } from './components/aplicativo/app-telas/app-telas.component';
import { ContatoModuloComponent } from './modulos/contato-modulo/contato-modulo.component';
import { MapaModuloComponent } from './modulos/mapa-modulo/mapa-modulo.component';
import { MaskDirective } from './directives/mask.directive';
import { HorarioCultoModuloComponent } from './modulos/horario-culto-modulo/horario-culto-modulo.component';
import { PodcastModuloComponent } from './modulos/podcast-modulo/podcast-modulo.component';
import { LogoFooterModuloComponent } from './modulos/logo-footer-modulo/logo-footer-modulo.component';
import { MenuFooterPartialComponent } from './components/partial/menu-footer-partial/menu-footer-partial.component';
import { VisaoModuloComponent } from './modulos/visao-modulo/visao-modulo.component';
import { DizimoOfertaPageComponent } from './pages/dizimo-oferta-page/dizimo-oferta-page.component';
import { ChamadaModuloComponent } from './modulos/chamada-modulo/chamada-modulo.component';
import { ConexoesPageComponent } from './pages/conexoes-page/conexoes-page.component';
import { LiderancaPageComponent } from './pages/lideranca-page/lideranca-page.component';
import { ValorItemComponent } from './components/valores/valor-item/valor-item.component';
import { ConexaoItemComponent } from './components/conexao/conexao-item/conexao-item.component';
import { GreenhouseSchoolPageComponent } from './pages/greenhouse-school-page/greenhouse-school-page.component';
import { AgendaPageComponent } from './pages/agenda-page/agenda-page.component';
import { EventoItemComponent } from './components/evento/evento-item/evento-item.component';
import { JejumColetivoPageComponent } from './pages/jejum-coletivo-page/jejum-coletivo-page.component';
import { EventoComponent } from './modulos/evento/evento.component';
import { EventoPageComponent } from './pages/evento/evento-page/evento-page.component';
import { NegocioPageComponent } from './pages/negocio/negocio-page/negocio-page.component';
import { NegocioItemComponent } from './components/negocios/negocio-item/negocio-item.component';
import { NegociosListComponent } from './components/negocios/negocios-list/negocios-list.component';
import { NegocioItemModalComponent } from './components/negocios/negocio-item-modal/negocio-item-modal.component';

@NgModule({
    declarations: [
        AppComponent,
        HomePage,
        Modulo,
        ModuloLogo,
        MenuComponent,
        HeaderComponent,
        BannerSliderComponent,
        RedeSocialComponent,
        NewsletterComponent,
        WhatsappComponent,
        FooterComponent,
        FaleConoscoComponent,
        PhoneMaskDirective,
        ParceirosComponent,
        SistemaDeGestaoPage,
        EcommercePage,
        AplicativoPage,
        DashboardPage,
        ContatoPage,
        SobrePage,
        SejaNossoParceiroPage,
        CasesComponent,
        ModalInfo,
        LoaderComponent,
        ContatoConsultorComponent,
        SafeHtmlPipe,
        ServicosComponent,
        PageErrorComponent,
        BreadcrumbsComponent,
        MenuServicosComponent,
        FuncionalidadeItemComponent,
        CaseItemComponent,
        ServicosPage,
        ModalSugestao,
        TopoPartialComponent,
        EnderecoModuloComponent,
        ClienteModuloComponent,
        ManagetourModuloComponent,
        EcommerceModuloComponent,
        ApplicativoModuloComponent,
        AppTelasComponent,
        ContatoModuloComponent,
        MapaModuloComponent,
        MaskDirective,
        HorarioCultoModuloComponent,
        PodcastModuloComponent,
        LogoFooterModuloComponent,
        MenuFooterPartialComponent,
        VisaoModuloComponent,
        DizimoOfertaPageComponent,
        ChamadaModuloComponent,
        ConexoesPageComponent,
        LiderancaPageComponent,
        ValorItemComponent,
        ConexaoItemComponent,
        GreenhouseSchoolPageComponent,
        AgendaPageComponent,
        EventoItemComponent,
        JejumColetivoPageComponent,
        EventoComponent,
        EventoPageComponent,
        NegocioPageComponent,
        NegocioItemComponent,
        NegociosListComponent,
        NegocioItemModalComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        LazyLoadImageModule,
        DeviceDetectorModule.forRoot(),
        FormsModule,
        MatIconModule,
        MatDialogModule
    ],
    providers: [
        ModuloService,
        DataService,
        AppService,
        GtagService
    ],
    bootstrap: [AppComponent]
})
export class AppModule{ }
